// Definisco il modulo principlae
let adeMesApp = angular.module("AdeMesApp", [
    "ui.router",
    "ngMaterial",
    "ngStorage",
    "ngAria",
    "angular-jwt",
    "ngAnimate",
    "toaster",
    "md.data.table",
    "blockUI",
    "pascalprecht.translate",
    "ngSanitize",
    "ngResource",
    "oc.lazyLoad",
    "angularMoment",
    "lfNgMdFileInput",
    "ngMaterialDatePicker",
    "ngTouch",
    "ngCookies"
]);

// inizializzo i provider del modulo
adeMesApp.config(["$controllerProvider", "$compileProvider", "$filterProvider", "$provide", "$httpProvider",
    ($controllerProvider: any, $compileProvider: any, $filterProvider: any, $provide: any, $httpProvider: angular.IHttpProvider) => {
        adeMesApp.controller = $controllerProvider.register;
        adeMesApp.directive = $compileProvider.directive;
        adeMesApp.filter = $filterProvider.register;
        adeMesApp.factory = $provide.factory;
        adeMesApp.service = $provide.service;
        adeMesApp.constant = $provide.constant;
        adeMesApp.value = $provide.value;

        delete $httpProvider.defaults.headers.common["X-Requested-With"];
    }
]);

// inizializzo block-ui per la pagina di wait
adeMesApp.config(["blockUIConfig", "$locationProvider",
    (blockUIConfig: angular.blockUI.BlockUIConfig, $locationProvider: any) => {
        // Change the default overlay message: provide a custom template to use
        blockUIConfig.templateUrl = "app/shared/wait-page.template.html";
        // Change the default delay to 100ms before the blocking is visible
        blockUIConfig.delay = 250;
        // Disable automatically blocking of the user interface
        //blockUIConfig.autoBlock = false;
        // Disable auto body block
        //blockUIConfig.autoInjectBodyBlock = false;
       
    }
]);

// inizializzo il sistema multiligua
adeMesApp.config(["$translateProvider",
    ($translateProvider: angular.translate.ITranslateProvider) => {
        $translateProvider.useStaticFilesLoader({
            prefix: "l10n/",
            suffix: ".json"
        });
        // Tell the module what language to use by default
        $translateProvider.preferredLanguage("it");
        // Tell the module to store the language in the local storage
        $translateProvider.useLocalStorage();
        // Fix console strategy warning
        $translateProvider.useSanitizeValueStrategy(null);
    }
]);

adeMesApp.run(["$rootScope", "$state", "$stateParams","$sessionStorage","$localStorage","toaster","$location", "$mdDialog","blockUI","MainService",
    ($rootScope: any, $state: any, $stateParams: any,$sessionStorage: any, $localStorage: any,toaster: toaster.IToasterService,$location: any, $mdDialog: any, blockUI:angular.blockUI.BlockUIService, MainService:any) => {
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.socketopen = 'T';
        //Gestione Websocket per RFID

        if($localStorage.rfiduuid!=null && $localStorage.phaserfidid!=null) {
            loadSocket();            
        }

        $rootScope.$on('$locationChangeStart', function () {
            event.preventDefault();
            $rootScope.actualLocation = $location.path();
        });

        $rootScope.$watch(function () { return $location.path() }, function (newLocation: string, oldLocation: any) {
            if ($rootScope.actualLocation === newLocation) {
                console.log("indietro");
            }
        });

        function loadSocket(){
            console.log("LOAD SOCKET");
            $rootScope.socketopen = 'N';
            if($sessionStorage.configData!=null && $rootScope.socket==null && $sessionStorage.configData.baseServicesUrl!=null){
                
                var str = $sessionStorage.configData.baseServicesUrl;
                
                var newstr = str.replace("http", "ws");
                console.log("URL SOCKET "+newstr);
                
                $rootScope.socket = new WebSocket(newstr+"socketademes?uuid="+$localStorage.rfiduuid+"&phaseid="+$localStorage.phaserfidid+"&adclientid="+$sessionStorage.configData.adClientId);
                
                $rootScope.socket.onopen = function(){
                    console.log("connessione effettuata");
                    $rootScope.socketopen = 'Y';                    
                    $rootScope.$digest();
                }
                
                $rootScope.socket.onclose = function () {
                    console.log("chiusura della connessione");
                    $rootScope.socketopen = 'N';
                    $rootScope.socket = null;
                    $rootScope.$digest();
                    //Ritento la connessione dopo 5 secondi
                    setTimeout(loadSocket,5000);
                }
                
                $rootScope.socket.onerror = function () {
                    console.log("errore nella connessione");  
                    $rootScope.socketopen = 'N';  
                    $rootScope.$digest();                
                }
                
                $rootScope.socket.onmessage = function (event: any) {
                    var operationbean = JSON.parse(event.data);
                    console.log(event.data);
                    if (operationbean.operation == 'LOGIN') {
                        //Login effettuato
                        $sessionStorage.identityToken = operationbean.token;
                        $state.go("customers");
                    } else if (operationbean.operation == 'START') {
                        //Inserire messaggio di avvenuto START
                        $sessionStorage.identityToken = '';
                        $rootScope.msg = operationbean.message;
                        $rootScope.msg_type = 'info';
                        $state.go("login");                    
                    } else if (operationbean.operation == 'STOP') {
                        //Inserire messaggio di avvenuto STOP
                        $sessionStorage.identityToken = '';
                        $rootScope.msg = operationbean.message;
                        $rootScope.msg_type = 'info';
                        $state.go("login");
                        
                    } else if(operationbean.operation == 'LOCKUI'){
                        blockUI.start();
                    } else if(operationbean.operation == 'ERROR'){
                        $sessionStorage.identityToken = '';
                        $rootScope.msg = operationbean.message;
                        $rootScope.msg_type = 'error';
                        $state.go("login");
                    }
                }

            }else{
                setTimeout(loadSocket,5000);
            }


        }
    }
]);

// inizializzo le rotte per le pagine
adeMesApp.config(["$stateProvider", "$urlRouterProvider",
    ($stateProvider: angular.ui.IStateProvider, $urlRouterProvider: angular.ui.IUrlRouterProvider) => {
        //$urlRouterProvider.otherwise("/calendar");
        $urlRouterProvider.otherwise("/calendar");
        
        $stateProvider.state("login", {
            url: "/login",
            templateUrl: "app/routes/login/login.html",
            controller: "LoginController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/login/LoginController.js",
                            "js/routes/login/LoginService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: false
            }
        }).state("customers", {
            url: "/customer",
            templateUrl: "app/routes/customers/customers.html",
            controller: "CustomersController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/customers/CustomersController.js",
                            "js/routes/customers/CustomersService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("phase-groups", {
            url: "/customer/:customerId/:projectId/:projectLineId/phase-group",
            templateUrl: "app/routes/phase-groups/phase-groups.html",
            controller: "PhaseGroupsController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/phase-groups/PhaseGroupsController.js",
                            "js/routes/phase-groups/PhaseGroupsService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("phases", {
            url: "/customer/:customerId/:projectId/:projectLineId/phase-group/:phaseGroupId/phase?phaseId",
            templateUrl: "app/routes/phases/phases.html",
            controller: "PhasesController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/phases/PhasesController.js",
                            "js/routes/phases/PhasesService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("report-list", {
            url: "/report-list",
            templateUrl: "app/routes/report-list/reportList.html",
            controller: "ReportListController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/report-list/ReportListController.js",
                            "js/routes/report-list/ReportListService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("client", {
            url: "/client",
            templateUrl: "app/routes/client/client.html",
            controller: "clientController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/report-list/clientController.js",
                            "js/routes/report-list/clientService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("activity-detail", {
            url: "/activityDetails/:idActivityDetail",
            templateUrl: "app/routes/activity-detail/activity-detail.html",
            controller: "ActivityDetailController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/activity-detail/ActivityDetailController.js",
                            "js/routes/activity-detail/ActivityDetailService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("means-transport", {
            url: "/activityDetails/:idActivityDetail/meansTransport",
            templateUrl: "app/routes/means-transport/means-transport.html",
            controller: "MeansTransportController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/means-transport/MeansTransportController.js",
                            "js/routes/means-transport/MeansTransportService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("equipement", {
            url: "/activityDetails/:idActivityDetail/equipement",
            templateUrl: "app/routes/equipement/equipement.html",
            controller: "EquipementController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/equipement/EquipementController.js",
                            "js/routes/equipement/EquipementService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("activities", {
            url: "/activityDetails/:idActivityDetail/activities",
            templateUrl: "app/routes/activities/activities.html",
            controller: "ActivitiesController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/activities/ActivitiesController.js",
                            "js/routes/activities/ActivitiesService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("hour-detail", {
            url: "/activityDetails/:idActivityDetail/hourDetail",
            templateUrl: "app/routes/hour-detail/hour-detail.html",
            controller: "HourDetailController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/hour-detail/HourDetailController.js",
                            "js/routes/hour-detail/HourDetailService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("report", {
            url: "/activityDetails/:idActivityDetail/report",
            templateUrl: "app/routes/report/report.html",
            controller: "ReportController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/report/ReportController.js",
                            "js/routes/report/ReportService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        }).state("calendar", {
            url: "/calendar",
            templateUrl: "app/routes/calendar/calendar.html",
            controller: "CalendarController",
            resolve: {
                deps: ["$ocLazyLoad",
                    ($ocLazyLoad: any) => {
                        return $ocLazyLoad.load([
                            "js/routes/calendar/CalendarController.js",
                            "js/routes/calendar/CalendarService.js"
                        ]);
                    }
                ]
            },
            data: {
                requiredAuthId: true,
                requiredRole: "ROLE_BASE"
            }
        });
    }
]);

declare var Cookies: any;
adeMesApp.factory("cookiesNoConflict", () => {
    return Cookies.noConflict();
});

// creo un interceptor per la verifica dei permessi utente
adeMesApp.factory("tokenInjectInterceptor",
    ($q: angular.IQService, $location: ng.ILocationService, $sessionStorage: any, GlobalApplicationData: any, $injector: ng.auto.IInjectorService) => {
        return {
            request: (config: angular.IRequestConfig) => {
                config.headers = config.headers || {};
                let MainService: any = $injector.get("MainService");
                
                if (!GlobalApplicationData.identityToken && $sessionStorage.identityToken) {
                    MainService.setJWT($sessionStorage.identityToken);
                }

                if (GlobalApplicationData.identityToken) {
                    config.headers.Authorization = "Bearer " + GlobalApplicationData.identityToken;
                } else {
                    // Non ho i dati, quindi vado alla pagina che cerca o ricrea il token di autenticazione
                    // Ammesso che non stia già andando lì... (o stia caricando il main template che fa parte del "lì")
                    if (config.url && config.url.indexOf("ts/routes/login/login.html") === -1) {
                        // Mi salvo dove era richiesto andare (se non ne ho già uno)
                        if (!GlobalApplicationData.orginalRequestedURL && $location.path().indexOf("/login") === -1) {
                            GlobalApplicationData.orginalRequestedURL = $location.path();
                        }
                        let $state: angular.ui.IStateService = $injector.get("$state");
                        if (!$state.current || ($state.current.data && $state.current.data.requiredAuthId)) {
                            $state.go("login");
                        }
                    }
                }
                return config;
            },

            responseError: (rejection: any) => {
                if (rejection.status == 401) {
                    // La sessione utente è sicuramente scaduta, quindi cancello anche il token
                    $sessionStorage.identityToken = null;
                    GlobalApplicationData.identityToken = null;
                    GlobalApplicationData.jwtPayload = null;
                    // Vado alla pagina che cerca o ricrea il token di autenticazione
                    var $state: any = $injector.get("$state");
                    console.log(rejection);
                    $state.go("login");
                }
                return $q.reject(rejection);
            }
        };
    }
);

// aggiungo l'interceptor per la verifica dei permessi utente alla lista degli interceptor
adeMesApp.config(["$httpProvider",
    ($httpProvider: angular.IHttpProvider) => {
        $httpProvider.interceptors.push("tokenInjectInterceptor");
    }
]);

adeMesApp.run((amMoment: any) => {
    amMoment.changeLocale("it");
});

// confiugro il calendario
adeMesApp.config(($mdDateLocaleProvider: angular.material.IDateLocaleProvider, moment: any) => {
    //$mdDateLocaleProvider.months = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];
    //$mdDateLocaleProvider.shortMonths = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic];
    //$mdDateLocaleProvider.days = ["domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"];
    //$mdDateLocaleProvider.shortDays = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];

    // Can change week display to start on Monday.
    $mdDateLocaleProvider.firstDayOfWeek = 1;

    // Example uses moment.js to parse and format dates.
    $mdDateLocaleProvider.parseDate = (dateString: string): Date => {
        var m = moment(dateString, "DD/MM/YYYY", true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    };

    $mdDateLocaleProvider.formatDate = (date: Date): string => {
        var m = moment(date);
        return m.isValid() ? m.format("DD/MM/YYYY") : "";
    };

    //$mdDateLocaleProvider.msgCalendar = "Calendario";
    //$mdDateLocaleProvider.msgOpenCalendar = "Apri calendario";
});

// nel passaggio tra uno state e l'atro controllo i permessi utente
adeMesApp.run(
    ($transitions: any, $sessionStorage: any) => {
        $transitions.onStart({}, (transition: any) => {
            let fromState = transition.from();
            let toState = transition.to();

            let RolesService = transition.injector().get("RolesService");
            if ($sessionStorage.identityToken && !RolesService.isAuthorizedForState(toState)) {
                // L'utente non ha l'autorizzazione alla pagina in cui cerca di andare, per cui lo reindirizzo alla main page
                return transition.router.stateService.target("customers");
            } else if (!$sessionStorage.identityToken && toState.name !== "login") {
                // L'utente non ha ancora effettuato la login, per cui lo reindirizzo alla login page
                return transition.router.stateService.target("login");
            }
        });
    }
);

adeMesApp.run(
    (ConfigService: any) => {
        ConfigService.init();
    }
);